module.exports = __webpack_public_path__ + "img/active_product1.2f76204.png";